import { all, takeLatest } from 'redux-saga/effects';
import { types as commonTypes } from '../reducers/common';
import { types } from '../reducers/product';
import {
  getProductInfo,
} from './product';
import { getBusinessProps } from './common';


export default function* rootSaga() {
  yield all([
    takeLatest(types.GET_HOME_INFO_BEGINS, getProductInfo),
    takeLatest(types.GET_EXPERTO_INFO_BEGINS, getProductInfo),
    takeLatest(types.GET_BENEFICIOS_INFO_BEGINS, getProductInfo),
    takeLatest(types.GET_DIGITAL_INFO_BEGINS, getProductInfo),
    takeLatest(types.GET_CONSULTING_INFO_BEGINS, getProductInfo),
    takeLatest(types.GET_BONOPYME_INFO_BEGINS, getProductInfo),
    takeLatest(types.GET_AYUDA_INFO_BEGINS, getProductInfo),
    takeLatest(types.GET_CONTRATOS_BEGINS, getProductInfo),
    takeLatest(commonTypes.GET_BUSINESS_CONSTANTS, getBusinessProps),
  ]);
}
